import React from "react";
import { withRouter } from "react-router";
import { Card, ErrorTile } from "uikit/components";
import styles from "./SectionErrorBoundary.module.styl";

class SectionErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidMount() {
        this.unlisten = this.props.history.listen(() => {
            if (this.state.hasError) {
                this.setState({ hasError: false });
            }
        });
    }

    componentWillUnmount() {
        const unlisten = this.unlisten;
        unlisten && unlisten();
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={styles.background}>
                    <Card className={styles.cardWrapper}>
                        <ErrorTile position={"fill"} />
                    </Card>
                </div>
            );
        }

        return this.props.children;
    }
}

export default withRouter(SectionErrorBoundary);
